import * as React from 'react';
import styled from 'styled-components';
import { SuccessMessage } from '../../../shared/form/SuccessMessage';

export interface IForgotPasswordProps {
  email: string;
  resetSent: boolean;
}

export const ForgotPassword = React.memo(
  (props: IForgotPasswordProps): React.ReactElement => {
    return (
      <Container>
        {!props.resetSent ? (
          <React.Fragment>
            <h1 id='forgot-password-heading' style={{ margin: '.5rem 1rem' }}>
              Reset Your Password
            </h1>
            <Description>
              We'll send a password reset link to <strong>{props.email}</strong>
            </Description>
            <Instructions>
              Click the "Send Reset Link" button below to receive an email with
              instructions to reset your password.
            </Instructions>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <h1 id='success-heading' style={{ margin: '.5rem 1rem' }}>
              Check Your Email
            </h1>
            <SuccessMessage style={{ margin: '1rem' }}>
              A password reset link has been sent to <strong>{props.email}</strong>
            </SuccessMessage>
            <Instructions>
              Please check your email and click the link to reset your password.
              The link will expire in 1 hour.
            </Instructions>
          </React.Fragment>
        )}
      </Container>
    );
  },
  (
    prevProps: Readonly<IForgotPasswordProps>,
    nextProps: Readonly<IForgotPasswordProps>
  ): boolean => {
    return (
      prevProps.email === nextProps.email &&
      prevProps.resetSent === nextProps.resetSent
    );
  }
);

ForgotPassword.displayName = 'ForgotPassword';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 20px;
  width: 100%;
  height: 100%;
`;

const Description = styled.div`
  margin: 0.5rem 1rem;
  color: var(--color-primary-text);
  font-size: 14px;
`;

const Instructions = styled.div`
  margin: 1rem;
  color: var(--color-secondary-text);
  font-size: 13px;
  font-style: italic;
`;
